<template>
    <BasicCombobox
        :label="label"
        :options="items"
        v-model="model"
    />
</template>

<script setup>
import { computed, watch } from 'vue';
import BasicCombobox from '../BasicCombobox.vue';

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    modelValue: {
        type: String,
        default: ''
    },
    refine: {
        type: Function,
        required: true
    },
    items: {
        type: Array,
        required: true
    }
})

const emit = defineEmits(['update:modelValue'])

const model = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
})

watch(() => props.modelValue, (val) => {
    props.refine(val);
});
</script>